import type { VisitorChatRecentInboundQuery } from "@/lib/graphql/queries/generated/messaging.generated";
import type { ThreadUpdateEvent } from "@/lib/use-visitor-threads-realtime";

type RecentInbound = NonNullable<VisitorChatRecentInboundQuery["visitorChatRecentInbound"]>;

/** The Home `recent-message` row for an announced `threadUpdated` content frame (written to the Apollo cache). */
export function recentInboundFromFrame(
  e: Pick<
    ThreadUpdateEvent,
    | "threadId"
    | "lastMessageId"
    | "lastMessagePreview"
    | "lastMessageAt"
    | "lastMessageSenderKind"
    | "lastMessageSenderName"
    | "lastMessageSenderAvatar"
  >,
): RecentInbound {
  return {
    __typename: "VisitorChatRecentInbound",
    id: e.lastMessageId ?? `${e.threadId}@${e.lastMessageAt ?? ""}`,
    text: e.lastMessagePreview ?? null,
    caption: null,
    createdAt: e.lastMessageAt ?? new Date().toISOString(),
    sender: {
      __typename: "VisitorUnreadSender",
      kind: e.lastMessageSenderKind ?? "operator",
      name: e.lastMessageSenderName ?? "",
      avatar: e.lastMessageSenderAvatar ?? null,
    },
  };
}
